import { vec3 } from 'gl-matrix';
import { ArrayTexture } from '../texture';

/**
 * Hardcoded slot count of the terrain texture-splatting shader. Vertex COLOR_0 weights and
 * every slot-indexed uniform on [TerrainMaterial] assume exactly this many entries.
 */
export const TERRAIN_SLOT_COUNT = 4;

/**
 * Material shape for the `gbuffer-terrain` shader. Not a subclass of Material — the engine
 * renderer branches on `instanceof TerrainMaterial` to pick the terrain shader path instead
 * of the standard PBR path.
 */
export class TerrainMaterial {
  /** sRGB 4-layer TEXTURE_2D_ARRAY (required). Layer i is the albedo for slot i. */
  albedoArray: ArrayTexture;

  /** Linear 4-layer TEXTURE_2D_ARRAY (optional). If absent, the shader falls back to a flat normal. */
  normalArray?: ArrayTexture;

  /** Linear 4-layer TEXTURE_2D_ARRAY, grayscale in R (optional). If absent, uses [slotRoughnessFallback]. */
  roughnessArray?: ArrayTexture;

  /** Flat color per slot used when [slotHasAlbedo] is false for that slot. */
  slotColors: vec3[] = [
    vec3.fromValues(0.5, 0.5, 0.5),
    vec3.fromValues(0.5, 0.5, 0.5),
    vec3.fromValues(0.5, 0.5, 0.5),
    vec3.fromValues(0.5, 0.5, 0.5),
  ];

  /** Triplanar tiling multiplier per slot (world-space units per texture tile). */
  slotTiling: number[] = [1, 1, 1, 1];

  /** True if slot i has a valid albedo layer to sample; else the shader uses [slotColors][i]. */
  slotHasAlbedo: boolean[] = [false, false, false, false];

  /** Fallback scalar roughness when [roughnessArray] is unset. */
  slotRoughnessFallback: number = 0.8;

  constructor(albedoArray: ArrayTexture) {
    this.albedoArray = albedoArray;
  }
}
